import { render, staticRenderFns } from "./RequestPolicies.vue?vue&type=template&id=df14793c&"
import script from "./RequestPolicies.vue?vue&type=script&lang=js&"
export * from "./RequestPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports